module.exports = __webpack_public_path__ + "static/media/image-logo-pertamina.ca2913fa.png";